module.exports = __webpack_public_path__ + "img/netshoes-thumb.6141404b.jpg";